//#region src/internal/tool-helpers/results.ts
/**
* Marks a tool result as structured-only. The server generates compatibility
* text for clients that do not read structuredContent yet.
*/
function structuredResult(structuredContent) {
	return { structuredContent };
}

//#endregion
export { structuredResult };
//# sourceMappingURL=results-NF1RJbDZ.js.map